import ConfigProvider from 'antd/es/config-provider';

import * as Style from './InputPassowrd.style';

interface Props {
  prefix?: string;
  type?: string;
  visibilityToggle?: boolean;
  placeholder?: string;
  width?: string;
  height?: string;
}

const Input = ({
  prefix,
  type,
  visibilityToggle,
  placeholder,
  width,
  height,
  ...rest
}: Props) => {
  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        components: {
          Input: {
            activeBg: '#ffffffb3',
            hoverBg: '#ffffffb3',
            paddingInline: 25,
          },
        },
      }}
    >
      <Style.InputPassword
        variant="borderless"
        prefix={prefix}
        type={type}
        visibilityToggle={visibilityToggle}
        placeholder={placeholder}
        width={width}
        height={height}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default Input;
